module.exports = __webpack_public_path__ + "img/bg-375.267ff660.webp";